import {store} from '../store'

const hasModuleActive = (module) => {
    return store.state.benutzer.info.modules.includes(module);
}

export {
    hasModuleActive
}